import { useRuntimeAuthStore } from '@xstudios/xapp-auth/stores/runtimeAuthStore'

export function useAuthStore() {
  return useRuntimeAuthStore()
}
